//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import DetailChart from '~/components/detail/mobile/detail_chart'
import Convertor from '~/components/detail/desktop/convertor'
import DetailWeblog from '~/components/detail/mobile/detail_weblog'
import SingleLoading from '~/components/partials/loading/single_loading'
export default {
  name: 'ChartWeblog',
  components: {
    DetailChart,
    Convertor,
    DetailWeblog,
    SingleLoading
  },
  props: {
    coin: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      intervals: ['1D', '1W', '1M'],
      selectedInterval: '',
      oneDayTimestamp: 24 * 3400 * 1000,
      nowTime: new Date().getTime(),
      disableInterval: false,
      exchangerID: 1
    }
  },
  computed: {
    ...mapGetters({
      loading: 'coins/loading'
    })
  },
  watch: {
    async selectedInterval (val) {
      if (this.coin.data.chart_slug) {
        if (val === '1D') {
          await this.getData(val, 1)
        } else if (val === '1W') {
          await this.getData('7D', 7)
        } else {
          await this.getData(val, 30)
        }
      }
    }
  },
  mounted () {
    this.selectedInterval = '1D'
  },
  methods: {
    async getData (interval, day) {
      this.disableInterval = true
      await this.$store.dispatch('coins/getChartData', {
        symbol: this.coin.data.chart_slug,
        interval,
        start: this.nowTime - (this.oneDayTimestamp * day)
      })
      this.disableInterval = false
    }
  }
}
